<ng-container *ngIf="error || errorServer">
  <div class="wrapper">
    <div class="errorCode">{{errorCode}}</div>
    <div class="errorMessage">{{errorMessage}}</div>
    <div class="reload">
      <button mat-stroked-button color="accent" (click)="reload()">Reload</button>
    </div>
  </div>
</ng-container>
